/**
 * 💡 SKELETON VALIDATOR
 * Purpose: Satisfy TemplateManagementService dependencies to allow compilation.
 */
class TemplateValidationService {
  /**
   * Returns a valid pass-through result to allow UI testing.
   */
  validateTemplate(template) {
    console.log("🛠️ [VALIDATOR] Skeleton validation triggered for:", template.name);
    return {
      isValid: true,
      errors: []
    };
  }

  validateSearchQuery(query) {
    return query && query.trim().length > 0;
  }
}

export default TemplateValidationService;